import {
  isPartnershipEligible,
} from '@shared/partnershipEligibility';
import { FundingPolicyType } from '@shared';
import { cn } from '@/lib';

interface PartnershipEligibilityDisclaimerProps {
  policyType: number;
  state: string;
  primaryAge: number;
  bioPercent: string | number | null;
  isCompoundInflation?: boolean;
  className?: string;
}

export function PartnershipEligibilityDisclaimer({
  policyType,
  state,
  primaryAge,
  bioPercent,
  isCompoundInflation,
  className,
}: PartnershipEligibilityDisclaimerProps) {
  if (policyType !== FundingPolicyType.careScoutCareAssurance) {
    return null;
  }

  const eligible = isPartnershipEligible({
    state,
    ageAtIssue: primaryAge,
    bioPercent,
    policyType,
    isCompoundInflation,
  });

  if (!eligible) {
    return null;
  }
  return (
    <p
      className={cn('text-xs text-gray-700', className)}
      data-testid="partnership-eligibility-disclaimer"
    >
     ** This policy may qualify as a Long-Term Care Partnership Policy, which may allow you to protect assets through Medicaid asset disregard if you later apply. Eligibility requirements and state rules apply.
    </p>
  );
}
